import { isNotEmptyArray } from 'utils/misc';
import { getKyClient } from './client';

export const fetchCancellationReasons = async (adfitNo) => {
  const url = `v1.0/accounts/${adfitNo}/customcancelreasons`;
  const kyClient = await getKyClient();
  const result = await kyClient.get(url).json();
  return isNotEmptyArray(result)
    ? result.map(({ reasonName }) => reasonName)
    : result;
};
